import Vue from 'vue';
import Vuetify from 'vuetify/lib/';
import { Touch } from 'vuetify/lib/directives'; /* Temporary import since it's not working for some reason */

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#00796B',
        accent: '#463730',
        secondary: '#759FBC',
        info: '#90C3C8',
        warning: '#F18F01',
        error: '#FF5252',
        success: '#7CDF64',
      },
      dark: {
        primary: '#00796B',
        accent: '#463730',
        secondary: '#759FBC',
        info: '#90C3C8',
        warning: '#F18F01',
        error: '#FF5252',
        success: '#7CDF64',
      },
      /* newlight: {
        primary: '#00796B',
        accent: '#ef476f',
        secondary: '#ffd166',
        info: '#06d6a0',
        warning: '#4ecdc4',
        error: '#FF5252',
        success: '#7CDF64',
      }*/
    },
  },
  /* Temporary import since it's not working for some reason */
  directives: {
    Touch,
  },
});
